export default __webpack_public_path__ + "static/slider-image-2-40245d86eb75f34514522d83347d4fd1.png";